/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 184a00ce8c0820b9f30e843b83a02cfbde1f2078e2c79fbcd6e62e412bf38c30
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './AlertPanel.style'

type AlertPanelOwnProps = {
  className?: string
  actions?: React.ReactNode
  icon?: React.ReactNode
  linkText?: React.ReactNode
  subtitle?: React.ReactNode
  textStyle?: 'color' | 'monochrome'
  title?: string
  variant?: 'ai' | 'severe' | 'soft' | 'warning'
}

export type AlertPanelProps = AlertPanelOwnProps & Omit<ComponentProps<'div'>, keyof AlertPanelOwnProps>

function AlertPanel(props: AlertPanelProps): ReactElement {
  const {
    children: _children,
    className = '',
    actions,
    icon,
    linkText,
    subtitle,
    textStyle = 'color',
    title,
    variant = 'soft',
    ...rest
  } = props

  return (
    <div
      className={cn('AlertPanel', className, textStyle, variant, { [`textStyle-${textStyle}`]: textStyle, [`variant-${variant}`]: variant, 'has-actions': Boolean(actions) })}
      css={style}
      {...rest}
      role={actions ? undefined : 'status'}
      aria-live={actions ? undefined : 'polite'}
    >
      <div className="content-row">
        {icon ? (
          <div aria-hidden={true} className="icon">
            {icon}
          </div>
        ) : null}
        <div className="content-stack">
          {title ? <div className="title">{title}</div> : null}
          {subtitle ? <div className="subtitle">{subtitle}</div> : null}
          {linkText ? <div className="linkText">{linkText}</div> : null}
        </div>
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </div>
  )
}

export default AlertPanel
